export const QUIZ_DIAGNOSTICS_SECTION_MARGIN = 8

export const QUIZ_DIAGNOSTICS_PERCENT_COLOR = '#444444'

export const QUIZ_DIAGNOSTICS_PERCENT_FONT_SIZE = 14

export const QUIZ_DIAGNOSTICS_PERCENT_LINE_HEIGHT = 14

export const QUIZ_DIAGNOSTICS_PROGRESS_BAR_HEIGHT = 40

export const QUIZ_DIAGNOSTICS_COURSE_BAR_WIDTH = 42

export const QUIZ_DIAGNOSTICS_CHAPTER_BAR_WIDTH = 26

export const QUIZ_DIAGNOSTICS_BAR_ROW_TOP =
  QUIZ_DIAGNOSTICS_PERCENT_LINE_HEIGHT + QUIZ_DIAGNOSTICS_SECTION_MARGIN

export const QUIZ_DIAGNOSTICS_ZERO_SCORE_BACKGROUND = '#FAD3D3'

export const QUIZ_DIAGNOSTICS_ZERO_SCORE_BACKGROUND_OPACITY = 0.28

/** Fixed width for the ALL / COURSE summary card only */
export const QUIZ_DIAGNOSTICS_ALL_CARD_WIDTH = 115

export const QUIZ_DIAGNOSTICS_ZERO_SCORE_STRIP_WIDTH = 80

export const QUIZ_DIAGNOSTICS_COMPACT_CARD_MAX_CHAPTERS = 5

export const QUIZ_COMPACT_CARD_MAX_CHAPTERS = 2

export const QUIZ_DIAGNOSTICS_COMPACT_CARD_HORIZONTAL_MARGIN = 5

export const QUIZ_DIAGNOSTICS_ALL_PROGRESS_BAR_COLOR = '#FDC800'

export const QUIZ_DIAGNOSTICS_GROUP_BOX_PADDING_TOP = 0

export const QUIZ_DIAGNOSTICS_GROUP_BOX_PADDING_HORIZONTAL = 0

export const QUIZ_DIAGNOSTICS_GROUP_BOX_PADDING_BOTTOM = 0

export const QUIZ_DIAGNOSTICS_GROUP_BOX_PADDING_TOP_NARROW = 0

export const QUIZ_DIAGNOSTICS_GROUP_BOX_PADDING_HORIZONTAL_NARROW = 16

export const QUIZ_DIAGNOSTICS_GROUP_BOX_PADDING_BOTTOM_NARROW = 20

export const QUIZ_DIAGNOSTICS_SUBTITLE_LINE_HEIGHT = 11.5

export const QUIZ_DIAGNOSTICS_SUBTITLE_MAX_LINES = 3

export const QUIZ_DIAGNOSTICS_SUBTITLE_MIN_HEIGHT =
  QUIZ_DIAGNOSTICS_SUBTITLE_LINE_HEIGHT * QUIZ_DIAGNOSTICS_SUBTITLE_MAX_LINES

export const QUIZ_DIAGNOSTICS_TITLE_LINE_HEIGHT = 14

export const QUIZ_DIAGNOSTICS_BOOK_TITLE_OFFSET = 4

export const QUIZ_DIAGNOSTICS_BOOK_TITLE_LINE_HEIGHT = 20

export const QUIZ_DIAGNOSTICS_BOOK_TITLE_SLOT_HEIGHT =
  QUIZ_DIAGNOSTICS_BOOK_TITLE_OFFSET + QUIZ_DIAGNOSTICS_BOOK_TITLE_LINE_HEIGHT

export const QUIZ_DIAGNOSTICS_BAR_COLUMN_MIN_HEIGHT =
  QUIZ_DIAGNOSTICS_PERCENT_LINE_HEIGHT +
  QUIZ_DIAGNOSTICS_SECTION_MARGIN +
  QUIZ_DIAGNOSTICS_PROGRESS_BAR_HEIGHT +
  QUIZ_DIAGNOSTICS_SECTION_MARGIN +
  QUIZ_DIAGNOSTICS_TITLE_LINE_HEIGHT +
  QUIZ_DIAGNOSTICS_SECTION_MARGIN +
  QUIZ_DIAGNOSTICS_SUBTITLE_MIN_HEIGHT
